// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G526KGcBaQCg2YBRyoQX {
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
}
.G526KGcBaQCg2YBRyoQX i {
  font-size: 18px;
}

/* Garder la même couleur au hover / focus */
.G526KGcBaQCg2YBRyoQX:hover,
.G526KGcBaQCg2YBRyoQX:focus,
.G526KGcBaQCg2YBRyoQX:active {
  background: white;
  border-color: #ccc;
}

.alUCiCIM1MBG8F0ZAEcI {
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 180px;
    width: max-content;
    white-space: nowrap;
    background-color: white;
    border: 1px solid #cfcfcf;
    border-radius: 6px;
    padding: 6px 0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 9999;
  }
  
  .uvGFlGMZdRviILvu3vbw {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    cursor: pointer;
    user-select: none;
    gap: 10px;
  }
  
  .uvGFlGMZdRviILvu3vbw:hover {
    background: #BFBFBF;
  }
  
  .kvwMbpNHSWCpVUdqmqgw {
    width: 20px;
    display: flex;
    justify-content: center;
  }
  
  .ljWF7AG8X7KiMmpNy4QA {
    flex: 1;
    font-size: 14px;
  }

  .RPRPt73rlFlXGFadVk0r {
    height: 1px;
    background: #e1e1e1;
    margin: 0 5px;
  }
  
  .ugXnXh_r_E3ciYo8E9XA {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }`, "",{"version":3,"sources":["webpack://./src/component/resultat/searchActionsMenu.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;AACA;EACE,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,uCAAuC;IACvC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB","sourcesContent":[".butMenu {\r\n    width: 30px;\r\n    height: 30px;\r\n    border: 1px solid #ccc;\r\n    background: white;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n.butMenu i {\r\n  font-size: 18px;\r\n}\r\n\r\n/* Garder la même couleur au hover / focus */\r\n.butMenu:hover,\r\n.butMenu:focus,\r\n.butMenu:active {\r\n  background: white;\r\n  border-color: #ccc;\r\n}\r\n\r\n.winMenu {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    min-width: 180px;\r\n    width: max-content;\r\n    white-space: nowrap;\r\n    background-color: white;\r\n    border: 1px solid #cfcfcf;\r\n    border-radius: 6px;\r\n    padding: 6px 0;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n    z-index: 9999;\r\n  }\r\n  \r\n  .winItem {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n    padding: 0 12px;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .winItem:hover {\r\n    background: #BFBFBF;\r\n  }\r\n  \r\n  .winIcon {\r\n    width: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .winLabel {\r\n    flex: 1;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .winSeparator {\r\n    height: 1px;\r\n    background: #e1e1e1;\r\n    margin: 0 5px;\r\n  }\r\n  \r\n  .disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"butMenu": `G526KGcBaQCg2YBRyoQX`,
	"winMenu": `alUCiCIM1MBG8F0ZAEcI`,
	"winItem": `uvGFlGMZdRviILvu3vbw`,
	"winIcon": `kvwMbpNHSWCpVUdqmqgw`,
	"winLabel": `ljWF7AG8X7KiMmpNy4QA`,
	"winSeparator": `RPRPt73rlFlXGFadVk0r`,
	"disabled": `ugXnXh_r_E3ciYo8E9XA`
};
export default ___CSS_LOADER_EXPORT___;
